import {
  Box,
  Card,
  Container,
  FormControlLabel,
  Grid,
  Pagination,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useGetProductsMutation } from "../redux/reducer/features/Product/productSlice";
import { AppFilter } from "../models/app/AppModels";
import PageLoader from "../compenents/app/PageLoader";
import NoImage from "../Assets/no-image.jpg";

export interface HomeProps {}

export const ProductsGallery: React.FunctionComponent<HomeProps> = () => {
  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 12,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });

  const [sectionFlag, setSectionFlag] = React.useState(false);
  const [productsData, productsDataResult] = useGetProductsMutation();
  const [products, setProducts] = React.useState<any[]>([]);
  const [productsCount, setProductsCount] = React.useState<number>(0);
  const [page, setPage] = React.useState<number>(1);
  const [search, setSearch] = React.useState("");

  let navigate = useNavigate();
  const fetchData = () => {
    productsData({ paging: { ...paging, sectionOnly: sectionFlag } });
  };
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPaging({ ...paging, pageIndex: value - 1 });
    setPage(value);
  };
  React.useEffect(() => {
    if (productsDataResult.data) {
      setProducts(productsDataResult.data.entityList);
      setProductsCount(productsDataResult.data.totalRecords);
    }
  }, [productsDataResult]);

  React.useEffect(() => {
    fetchData();
  }, [paging, sectionFlag]);

  const debounce = (func: Function, delay: number) => {
    let timer: ReturnType<typeof setTimeout>;
    return function (this: any, ...args: any[]) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const handleSearchTextChange = useCallback(
    debounce((value: any) => {
      console.log(value);
      setPaging({ ...paging, quickFilterValues: [value], pageIndex: 0 });
      setPage(1);
    }, 1000),
    []
  );
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearch(value);
    handleSearchTextChange(value);
  };
  const openProductDetail = (productId: any) => {
    window.open("/ProductDetail/" + productId);
  };
  return (
    <>
      <Container maxWidth={false}>
        <PageLoader isLoading={productsDataResult.isLoading}></PageLoader>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={3}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
            Gallery
          </Typography>
          <FormControlLabel
            control={
              <Switch
                name="jason"
                value={sectionFlag}
                onChange={() => setSectionFlag(!sectionFlag)}
              />
            }
            label="Parts Sections only"
          />
        </Stack>
        <Card
          sx={{
            minHeight: "70vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box textAlign="right">
            <TextField
              id="search"
              name="search"
              label="Search.."
              variant="standard"
              size="small"
              onChange={handleChange}
              value={search}
            />
          </Box>
          <Box mt={3} sx={{ width: "100%" }}>
            <Grid container ml={2} spacing={5}>
              {products && products.length > 0
                ? products.map((item) => (
                    <Grid
                      item
                      xs={12}
                      md={3}
                      display="flex"
                      alignContent="flex-start"
                      justifyContent="flex-start"
                      flexDirection="column"
                    >
                      <div
                        onClick={() => {
                          openProductDetail(item?.id);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <Box
                          style={{
                            width: "200px",
                            height: "200px",
                            backgroundColor: "white",
                          }}
                        >
                          <img
                            style={{ maxWidth: "100%", maxHeight: "100%" }}
                            alt=""
                            src={
                              item.images.length > 0
                                ? item.images[0].absoluteUrl
                                : NoImage
                            }
                          ></img>
                        </Box>
                        <Typography color="primary">{item.title}</Typography>
                        <Typography fontSize="12px">
                          {item.modelName}
                        </Typography>
                        <Typography fontSize="12px">
                          <b>sku:</b>
                          {item.sku}
                        </Typography>
                      </div>
                    </Grid>
                  ))
                : ""}
            </Grid>
          </Box>
          <Box mt={3} alignSelf="center" p={3}>
            <Pagination
              count={Math.ceil(productsCount / paging.pageSize)}
              shape="rounded"
              page={page}
              onChange={handlePageChange}
            />
          </Box>
        </Card>
      </Container>
    </>
  );
};
